export default "__VITE_ASSET__D4f0tLZC__"